import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconSmartHomeProps } from './IconSmartHome.types'
import * as Styled from './styles/IconSmartHome.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSmartHome: FC<IconSmartHomeProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSmartHomeProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconSmartHomeProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M15.898 6.488V2.566h-1.941m2.988 6.707c.535-.441.774-1.207.266-1.714-.195-.196-.684-.59-1.305-1.07'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M13.957 2.566c-.7 0-1.27.567-1.273 1.27v.25c-.848-.625-1.47-1.074-1.47-1.074-.902-.719-1.675-.555-2.374 0 0 0-5.43 4.02-5.992 4.55-.883.82.125 2.063 1.183 2.063H4.5v6.27a1.584 1.584 0 0 0 1.578 1.578h7.145m2.675 2.382h2.09'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M13.457 12.723v-1.946c0-.691.559-1.25 1.25-1.25h5.832V20.25c0 .691-.562 1.25-1.25 1.25h-4.578c-.688 0-1.25-.559-1.25-1.25v-7.527'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconSmartHome
